exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".yxtbiz-group-member-drawer .yxt-drawer__body{padding:0}.yxtbiz-group-member-drawer *{box-sizing:border-box}.yxtbiz-group-member-drawer--hidden{display:none}.yxtbiz-group-member-drawer--transparent{pointer-events:none}.yxtbiz-group-member-drawer--transparent .yxt-drawer__container{pointer-events:none}\n", ""]);

